import ErrorContextProvider, { ErrorContext } from './ErrorContext';

export { ErrorContext };
export default ErrorContextProvider;
